/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaMidstayClean: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="midstayClean" viewBox="0 0 6 12">
      <g
        id="V3-Mobile"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="all-Cleans-2-Midstay-Copy-6"
          transform="translate(-21.000000, -180.000000)"
        >
          <g
            id="icon/-hanger-3-copy"
            transform="translate(19.000000, 181.000000)"
          >
            <g id="Group-16">
              <rect id="Rectangle" x="0" y="0" width="10" height="10"></rect>
            </g>
            <g
              id="noun_door-tag_1448479"
              transform="translate(2.500000, 0.200000)"
              fill="currentColor"
              stroke="currentColor"
            >
              <g id="Group" fillRule="nonzero" strokeWidth="0.7">
                <path
                  d="M4.93866667,2.38573333 C4.93866667,1.1116 3.85115873,0.0750666667 2.51436612,0.0750666667 C1.17687405,0.0750666667 0.0886666667,1.1116 0.0886666667,2.38573333 C0.0886666667,2.45933333 0.151337564,2.51906667 0.228557062,2.51906667 C0.30577656,2.51906667 0.368447457,2.45933333 0.368447457,2.38573333 C0.368447457,1.25866667 1.33103327,0.341733333 2.51436612,0.341733333 C3.69685963,0.341733333 4.65888588,1.25866667 4.65888588,2.38573333 C4.65888588,3.51346667 3.69685963,4.43106667 2.51436612,4.43106667 C1.17687405,4.43106667 0.0886666667,5.4676 0.0886666667,6.74173333 C0.0886666667,6.74266667 0.0892262282,6.74346667 0.0892262282,6.7444 L0.0892262282,9.39173333 C0.0892262282,9.46546667 0.151897125,9.52506667 0.229116623,9.52506667 L4.79877627,9.52506667 C4.87613566,9.52506667 4.93866667,9.46546667 4.93866667,9.39173333 L4.93866667,2.38613333 L4.93866667,2.38613333 C4.93866667,2.38586667 4.93866667,2.38586667 4.93866667,2.38573333 Z M4.65888588,9.2584 L0.369007019,9.2584 L0.369007019,6.7416 C0.369007019,6.7408 0.368587347,6.74026667 0.368587347,6.73946667 C0.369846361,5.61346667 1.33187261,4.69773333 2.51436612,4.69773333 C3.44421758,4.69773333 4.25236439,4.1952 4.65888588,3.46066667 L4.65888588,9.2584 Z"
                  id="Shape"
                ></path>
                <path
                  d="M3.52133333,7.8 L1.43333333,7.8 C1.35973333,7.8 1.3,7.8596 1.3,7.93333333 C1.3,8.00706667 1.35973333,8.06666667 1.43333333,8.06666667 L3.52133333,8.06666667 C3.59506667,8.06666667 3.65466667,8.00706667 3.65466667,7.93333333 C3.65466667,7.8596 3.59506667,7.8 3.52133333,7.8 Z"
                  id="Path"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaMidstayClean)
